module.exports = __webpack_public_path__ + "staticVue/img/end.7787f90e.png";